import type { IconProps } from '@/shared/ui/icons/types';

export const PaperPlaneIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M21.5 2.5 2.5 10.5l7 2.5 2.5 7 9.5-17.5Z" />
    <path d="m9.5 13 12-10.5" />
  </svg>
);
